import {BenchlingState} from 'redux-stores/reduceApp';
import {HydratedFulfillment} from 'requests/fulfillments/HydratedFulfillmentConstants';

export class RequestFulfillmentModelSelector {
  constructor(readonly state: BenchlingState) {}

  getModel(modelKey: string): HydratedFulfillment | null {
    const {fulfillmentsById} = this.state.models.requests.fulfillments;
    const {requestsById, requestTasksById} = this.state.models.requests.inputs;
    const {sampleGroupsById} = this.state.models.sampleGroups;
    const {requestTaskSchemasById, requestSchemasById} = this.state.models.requests.schemas;

    if (
      fulfillmentsById == null ||
      requestsById == null ||
      requestTasksById == null ||
      sampleGroupsById == null ||
      requestSchemasById == null ||
      requestTaskSchemasById == null
    ) {
      return null;
    }
    const fulfillment = fulfillmentsById[modelKey];
    if (fulfillment == null) {
      return null;
    }
    const request = requestsById[fulfillment.requestId];
    const sampleGroup = sampleGroupsById[fulfillment.sampleGroupId!] || null;
    const requestTask = requestTasksById[fulfillment.requestTaskId!] || null;

    if (
      request == null ||
      (fulfillment.requestTaskId != null && requestTask == null) ||
      (fulfillment.sampleGroupId != null && sampleGroup == null)
    ) {
      return null;
    }
    const requestSchema = requestSchemasById[request.schemaId];
    const requestTaskSchema = requestTask ? requestTaskSchemasById[requestTask.schemaId] : null;
    if (requestSchema == null || (requestTask != null && requestTaskSchema == null)) {
      return null;
    }

    return {
      fulfillment,
      request,
      sampleGroup,
      requestTask,
      requestSchema,
      requestTaskSchema,
    };
  }
}
